// @flow
export const SALES_TYPES_FILTER_CLEAR: 'reports/SALES_TYPES_FILTER_CLEAR' = 'reports/SALES_TYPES_FILTER_CLEAR';
export const SALES_TYPES_FILTER_DELETE: 'reports/SALES_TYPES_FILTER_DELETE' = 'reports/SALES_TYPES_FILTER_DELETE';
export const SALES_TYPES_FILTER_SET: 'reports/SALES_TYPES_FILTER_SET' = 'reports/SALES_TYPES_FILTER_SET';
export const SALES_TYPES_FILTER_UPDATE: 'reports/SALES_TYPES_FILTER_UPDATE' = 'reports/SALES_TYPES_FILTER_UPDATE';
